import Cookies from 'js-cookie';

export function submitSubscription(formValues, authenticityToken, url = '/subscriptions') {
  const data = Object.assign(formValues, {signupUrl: window.location.pathname});

  return fetch(url, {
    method: 'post',
    body: JSON.stringify(data),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': authenticityToken,
    },
  }).then(Cookies.set('subscribed', true, {path: '/'}));
}
